import React from 'react';
import IconContainer from './icon_container';

export default props => (
  <IconContainer {...props}>
    <path fill="#fff" d="M0 0h50v51H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.844 49.688c13.168 0 23.843-10.676 23.843-23.844C48.688 12.675 38.013 2 24.845 2 11.675 2 1 12.675 1 25.844c0 13.168 10.675 23.843 23.844 23.843zm0 1c13.72 0 24.843-11.123 24.843-24.844C49.688 12.123 38.566 1 24.845 1S0 12.123 0 25.844c0 13.72 11.123 24.843 24.844 24.843z"
      fill="#4D4E4E"
    />
    <mask id="a" fill="#fff">
      <rect x="18.286" y="18.286" width="13.143" height="19.714" rx=".5" />
    </mask>
    <rect
      x="18.286"
      y="18.286"
      width="13.143"
      height="19.714"
      rx=".5"
      stroke="#4D4E4E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#a)"
    />
    <path
      d="M15 19.38h19.714M24.857 23.762v8.762M28.143 23.762v8.762M21.571 23.762v8.762"
      stroke="#4D4E4E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask id="b" fill="#fff">
      <rect x="20.477" y="15" width="8.762" height="4.381" rx=".5" />
    </mask>
    <rect
      x="20.477"
      y="15"
      width="8.762"
      height="4.381"
      rx=".5"
      stroke="#4D4E4E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#b)"
    />
  </IconContainer>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/trash_with_border_icon.jsx